@if (isLoading | async) {
  <div class="overlay">
    <div class="loader">Loading...</div>
  </div>
}
